import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { UpdateChecker } from "@/components/UpdateChecker";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import ManageBookingPage from "@/pages/ManageBookingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSlots from "@/pages/AdminSlots";
import AdminPlanning from "@/pages/AdminPlanning";
import AdminNewBooking from "@/pages/AdminNewBooking";
import AdminCustomers from "@/pages/AdminCustomers";
import AdminSakuraKnowledge from "@/pages/AdminSakuraKnowledge";
import AdminTicketSearch from "@/pages/AdminTicketSearch";
import AdminMassEmail from "@/pages/AdminMassEmail";
import AdminReferrals from "@/pages/AdminReferrals";
import AdminDeliverySlips from "@/pages/AdminDeliverySlips";
import AdminSnakeLeaderboard from "@/pages/AdminSnakeLeaderboard";
import AdminChatHistory from "@/pages/AdminChatHistory";
import AdminTrenitalia from "@/pages/AdminTrenitalia";
import AdminConcierge from "@/pages/AdminConcierge";
import ConciergeLogin from "@/pages/ConciergeLogin";
import ConciergePortal from "@/pages/ConciergePortal";
import DepositSlipPage from "@/pages/DepositSlipPage";
import CustomerAuth from "@/pages/CustomerAuth";
import CustomerDashboard from "@/pages/CustomerDashboard";
import SnakeSakura from "@/pages/SnakeSakura";
import AuthCallback from "@/pages/AuthCallback";
import EmailVerification from "@/pages/EmailVerification";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AudioDemo from "@/pages/AudioDemo";
import TrackingPage from "@/pages/TrackingPage";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/booking/:zoneId" element={<BookingPage />} />
          <Route path="/confirmation/:bookingId" element={<ConfirmationPage />} />
          <Route path="/manage/:bookingId" element={<ManageBookingPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/slots" element={<AdminSlots />} />
          <Route path="/admin/planning" element={<AdminPlanning />} />
          <Route path="/admin/booking/new" element={<AdminNewBooking />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/admin/sakura" element={<AdminSakuraKnowledge />} />
          <Route path="/admin/ticket" element={<AdminTicketSearch />} />
          <Route path="/admin/email" element={<AdminMassEmail />} />
          <Route path="/admin/referrals" element={<AdminReferrals />} />
          <Route path="/admin/delivery-slips" element={<AdminDeliverySlips />} />
          <Route path="/admin/snake-leaderboard" element={<AdminSnakeLeaderboard />} />
          <Route path="/admin/chat-history" element={<AdminChatHistory />} />
          <Route path="/admin/trenitalia" element={<AdminTrenitalia />} />
          <Route path="/admin/conciergerie" element={<AdminConcierge />} />
          <Route path="/etoile" element={<ConciergeLogin />} />
          <Route path="/etoile/espace" element={<ConciergePortal />} />
          <Route path="/admin/deposit/:customerId" element={<DepositSlipPage />} />
          {/* Customer routes */}
          <Route path="/connexion" element={<CustomerAuth />} />
          <Route path="/mon-compte" element={<CustomerDashboard />} />
          <Route path="/snake-sakura" element={<SnakeSakura />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/verification" element={<EmailVerification />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          {/* Tracking page for clients */}
          <Route path="/track/:bookingId" element={<TrackingPage />} />
          {/* Test page */}
          <Route path="/test-audio" element={<AudioDemo />} />
          {/* Legal pages */}
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <UpdateChecker />
    </div>
  );
}

export default App;
